


import { Checkbox, FormControlLabelProps, FormControlProps } from '@mui/material';
import { FC, ReactNode, useCallback } from 'react';

import { InputCheckboxsProps } from './types/FieldTypes';


export interface IInputCheckboxProps extends InputCheckboxsProps {
    FormControlProps?: FormControlProps,
    FormControlLabelProps?: FormControlLabelProps;
    helperText?: ReactNode;
}

const InputCheckboxField: FC<IInputCheckboxProps> = ({
    FieldInputProps: { state: { propertyPath, value }, actions: { update, blur, focus, touch } },
    onChange,
    FormControlProps,
    FormControlLabelProps,
    inputProps,
    disabled,
    helperText,
    ...rest
}) => {
    const onChangeCombined = useCallback((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        if (onChange) {
            onChange(event, checked);
        }

        update(checked, true, true, true);
    }, [onChange, update]);

    const onFocusCombined = useCallback((event: React.FocusEvent<HTMLInputElement>) => {
        if (inputProps?.onFocus) {
            inputProps.onFocus(event);
        }

        focus();
    }, [inputProps?.onFocus, focus]);

    const onBlurCombined = useCallback((event: React.FocusEvent<HTMLInputElement>) => {
        if (inputProps?.onBlur) {
            inputProps.onBlur(event);
        }

        blur();
        touch();
    }, [inputProps?.onBlur, blur, touch]);

    return (
        <Checkbox
            key={`${propertyPath}-checkbox`}
            {...rest as any}
            inputProps={{
                ...inputProps,
                onBlur: onBlurCombined,
                onFocus: onFocusCombined
            }}
            checked={value ?? false}
            onChange={onChangeCombined}
            disabled={disabled}
            color={rest?.color ? rest?.color : 'primary'}
        />
    );
}

export default InputCheckboxField